<script setup lang="ts">
  import { computed } from 'vue';
  import type { TrainingDetail } from '@/entities/Training';
  import { formatCivilDateToPtBR } from '@/shared/lib';
  import { formatTrainingControlValue } from '../../lib/formatTrainingControlValue';

  const props = defineProps<{
    approval: TrainingDetail['approval'];
  }>();

  const approvalDateLabel = computed(() =>
    props.approval?.date
      ? formatCivilDateToPtBR(props.approval.date)
      : formatTrainingControlValue(null)
  );
</script>

<template>
  <section
    data-testid="training-control-section-approval"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <h2 class="text-sm font-semibold text-gray-07">
      Responsável pela aprovação do treinamento
    </h2>

    <div class="grid gap-4 md:grid-cols-3">
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Responsável pela aprovação:</span>
        <span
          data-testid="training-control-approval-responsible"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ formatTrainingControlValue(approval?.responsible?.name) }}
        </span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Cargo:</span>
        <span
          data-testid="training-control-approval-position"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ formatTrainingControlValue(approval?.position?.name) }}
        </span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Data da aprovação:</span>
        <span
          data-testid="training-control-approval-date"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ approvalDateLabel }}
        </span>
      </div>
    </div>
  </section>
</template>
